/* eslint-disable max-len */

const IconUpgrade = () => {
    return (
        <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                marginRight: '10px'
            }}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.9164 10.4999C20.9164 4.7468 16.2528 0.083252 10.4997 0.083252C4.74655 0.083252 0.0830078 4.7468 0.0830078 10.4999C0.0830078 16.2531 4.74655 20.9166 10.4997 20.9166C16.2528 20.9166 20.9164 16.2531 20.9164 10.4999ZM6.8226 10.0103C6.67629 9.86386 6.59412 9.66529 6.59412 9.45826C6.59412 9.25122 6.67629 9.05266 6.8226 8.90617L9.9476 5.78117C10.0941 5.63487 10.2926 5.55269 10.4997 5.55269C10.7067 5.55269 10.9053 5.63487 11.0518 5.78117L14.1768 8.90617C14.2535 8.9777 14.3151 9.06395 14.3578 9.15978C14.4005 9.25561 14.4234 9.35906 14.4253 9.46396C14.4271 9.56886 14.4079 9.67306 14.3686 9.77034C14.3293 9.86762 14.2708 9.95599 14.1966 10.0302C14.1224 10.1044 14.034 10.1628 13.9368 10.2021C13.8395 10.2414 13.7353 10.2607 13.6304 10.2589C13.5255 10.257 13.422 10.2341 13.3262 10.1914C13.2304 10.1487 13.1441 10.0871 13.0726 10.0103L11.2809 8.21867V14.6666C11.2809 14.8738 11.1986 15.0725 11.0521 15.219C10.9056 15.3655 10.7069 15.4478 10.4997 15.4478C10.2925 15.4478 10.0938 15.3655 9.94725 15.219C9.80074 15.0725 9.71843 14.8738 9.71843 14.6666V8.21867L7.92676 10.0103C7.78028 10.1566 7.58171 10.2388 7.37468 10.2388C7.16765 10.2388 6.96908 10.1566 6.8226 10.0103Z"
                fill="#4EA953"
            />
        </svg>
    );
};

const IconUpload = () => {
    return (
        <svg
            width="15"
            height="18"
            viewBox="0 0 15 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginRight: '5px', transform: 'translateY(-2px)' }}
        >
            <path
                d="M7.5 12.625H9.58333V6.375H12.1875L7.5 1.6875M7.5 12.625H5.41667V6.375H2.8125L7.5 1.6875"
                fill="white"
            />
            <path
                d="M7.5 12.625H9.58333V6.375H12.1875L7.5 1.6875L2.8125 6.375H5.41667V12.625H7.5Z"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M1.25 16.7917H13.75H1.25Z" fill="white" />
            <path
                d="M1.25 16.7917H13.75"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

const IconDownload = () => {
    return (
        <svg
            width="27"
            height="27"
            viewBox="0 0 27 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0.5"
                y="0.5"
                width="26"
                height="26"
                rx="4.5"
                stroke="#027DB4"
            />
            <g clipPath="url(#clip0_389_2188)">
                <path
                    d="M19.0676 15.5659C19.3301 15.5659 19.5818 15.6702 19.7673 15.8557C19.9529 16.0413 20.0572 16.293 20.0572 16.5555V19.1944C20.0572 19.6318 19.8834 20.0513 19.5741 20.3606C19.2648 20.6699 18.8453 20.8437 18.4079 20.8437H9.17177C8.73434 20.8437 8.31484 20.6699 8.00553 20.3606C7.69623 20.0513 7.52246 19.6318 7.52246 19.1944V16.5555C7.52246 16.293 7.62672 16.0413 7.8123 15.8557C7.99789 15.6702 8.24959 15.5659 8.51204 15.5659C8.7745 15.5659 9.0262 15.6702 9.21179 15.8557C9.39737 16.0413 9.50163 16.293 9.50163 16.5555V18.8645H18.078V16.5555C18.078 16.293 18.1823 16.0413 18.3679 15.8557C18.5534 15.6702 18.8051 15.5659 19.0676 15.5659ZM13.7898 6.9895C14.0523 6.9895 14.304 7.09376 14.4896 7.27934C14.6751 7.46493 14.7794 7.71663 14.7794 7.97909V13.9403L15.8891 12.8307C16.0762 12.6536 16.3251 12.5564 16.5828 12.56C16.8404 12.5635 17.0866 12.6674 17.2688 12.8495C17.4511 13.0317 17.5551 13.2778 17.5587 13.5355C17.5624 13.7931 17.4654 14.042 17.2883 14.2293L14.6059 16.9124C14.3894 17.1287 14.0959 17.2502 13.7898 17.2502C13.4838 17.2502 13.1902 17.1287 12.9737 16.9124L10.2913 14.23C10.1111 14.0433 10.0113 13.7933 10.0136 13.5339C10.0158 13.2744 10.1199 13.0262 10.3034 12.8427C10.4868 12.6593 10.735 12.5552 10.9945 12.5529C11.254 12.5507 11.5039 12.6504 11.6906 12.8307L12.8002 13.9403V7.97909C12.8002 7.71663 12.9045 7.46493 13.0901 7.27934C13.2757 7.09376 13.5274 6.9895 13.7898 6.9895Z"
                    fill="#027DB4"
                />
                <path
                    d="M18.376 19.125C18.376 18.9557 18.3141 18.8092 18.1904 18.6855C18.0667 18.5618 17.9202 18.5 17.751 18.5C17.5817 18.5 17.4352 18.5618 17.3115 18.6855C17.1878 18.8092 17.126 18.9557 17.126 19.125C17.126 19.2943 17.1878 19.4408 17.3115 19.5645C17.4352 19.6882 17.5817 19.75 17.751 19.75C17.9202 19.75 18.0667 19.6882 18.1904 19.5645C18.3141 19.4408 18.376 19.2943 18.376 19.125ZM20.876 19.125C20.876 18.9557 20.8141 18.8092 20.6904 18.6855C20.5667 18.5618 20.4202 18.5 20.251 18.5C20.0817 18.5 19.9352 18.5618 19.8115 18.6855C19.6878 18.8092 19.626 18.9557 19.626 19.125C19.626 19.2943 19.6878 19.4408 19.8115 19.5645C19.9352 19.6882 20.0817 19.75 20.251 19.75C20.4202 19.75 20.5667 19.6882 20.6904 19.5645C20.8141 19.4408 20.876 19.2943 20.876 19.125ZM22.126 16.9375V20.0625C22.126 20.3229 22.0348 20.5443 21.8525 20.7266C21.6702 20.9089 21.4489 21 21.1885 21H6.81348C6.55306 21 6.33171 20.9089 6.14941 20.7266C5.96712 20.5443 5.87598 20.3229 5.87598 20.0625V16.9375C5.87598 16.6771 5.96712 16.4557 6.14941 16.2734C6.33171 16.0911 6.55306 16 6.81348 16H11.3545L12.6729 17.3281C13.0505 17.6927 13.4932 17.875 14.001 17.875C14.5088 17.875 14.9515 17.6927 15.3291 17.3281L16.6572 16H21.1885C21.4489 16 21.6702 16.0911 21.8525 16.2734C22.0348 16.4557 22.126 16.6771 22.126 16.9375ZM18.9521 11.3809C19.0628 11.6478 19.0173 11.8757 18.8154 12.0645L14.4404 16.4395C14.3232 16.5632 14.1768 16.625 14.001 16.625C13.8252 16.625 13.6787 16.5632 13.5615 16.4395L9.18652 12.0645C8.9847 11.8757 8.93913 11.6478 9.0498 11.3809C9.16048 11.127 9.35254 11 9.62598 11H12.126V6.625C12.126 6.45573 12.1878 6.30924 12.3115 6.18555C12.4352 6.06185 12.5817 6 12.751 6H15.251C15.4202 6 15.5667 6.06185 15.6904 6.18555C15.8141 6.30924 15.876 6.45573 15.876 6.625V11H18.376C18.6494 11 18.8415 11.127 18.9521 11.3809Z"
                    fill="#027DB4"
                />
            </g>
            <defs>
                <clipPath id="clip0_389_2188">
                    <rect
                        width="16.254"
                        height="15"
                        fill="white"
                        transform="translate(5.87305 6)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

const IconEdit = () => {
    return (
        <svg
            width="27"
            height="27"
            viewBox="0 0 27 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0.5"
                y="0.5"
                width="26"
                height="26"
                rx="4.5"
                stroke="#027DB4"
            />
            <path
                d="M8.75 17L8 20L11 19.25L19.6895 10.5605C19.9707 10.2792 20.1287 9.89776 20.1287 9.50002C20.1287 9.10227 19.9707 8.72081 19.6895 8.43952L19.5605 8.31052C19.2792 8.02931 18.8977 7.87134 18.5 7.87134C18.1023 7.87134 17.7208 8.02931 17.4395 8.31052L8.75 17Z"
                stroke="#027DB4"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.75 17L8 20L11 19.25L18.5 11.75L16.25 9.5L8.75 17Z"
                fill="#027DB4"
            />
            <path
                d="M16.25 9.5L18.5 11.75M14.75 20H20.75"
                stroke="#027DB4"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

const IconDelete = () => {
    return (
        <svg
            width="27"
            height="27"
            viewBox="0 0 27 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0.5"
                y="0.5"
                width="26"
                height="26"
                rx="4.5"
                stroke="#EB0000"
            />
            <path
                d="M8.25 19.625C8.25 20.5875 9.0375 21.375 10 21.375H17C17.9625 21.375 18.75 20.5875 18.75 19.625V9.125H8.25V19.625ZM11.0238 14.0163C10.8601 13.8526 10.7682 13.6307 10.7682 13.3994C10.7682 13.168 10.8601 12.9461 11.0238 12.7825C11.1874 12.6189 11.4093 12.527 11.6406 12.527C11.872 12.527 12.0939 12.6189 12.2575 12.7825L13.5 14.0163L14.7338 12.7825C14.8974 12.6189 15.1193 12.527 15.3506 12.527C15.582 12.527 15.8039 12.6189 15.9675 12.7825C16.1311 12.9461 16.223 13.168 16.223 13.3994C16.223 13.6307 16.1311 13.8526 15.9675 14.0163L14.7338 15.25L15.9675 16.4837C16.0485 16.5648 16.1128 16.6609 16.1566 16.7668C16.2005 16.8726 16.223 16.9861 16.223 17.1006C16.223 17.2152 16.2005 17.3286 16.1566 17.4345C16.1128 17.5403 16.0485 17.6365 15.9675 17.7175C15.8865 17.7985 15.7903 17.8628 15.6845 17.9066C15.5786 17.9505 15.4652 17.973 15.3506 17.973C15.2361 17.973 15.1226 17.9505 15.0168 17.9066C14.9109 17.8628 14.8148 17.7985 14.7338 17.7175L13.5 16.4837L12.2663 17.7175C12.1852 17.7985 12.0891 17.8628 11.9832 17.9066C11.8774 17.9505 11.7639 17.973 11.6494 17.973C11.5348 17.973 11.4214 17.9505 11.3155 17.9066C11.2097 17.8628 11.1135 17.7985 11.0325 17.7175C10.9515 17.6365 10.8872 17.5403 10.8434 17.4345C10.7995 17.3286 10.777 17.2152 10.777 17.1006C10.777 16.9861 10.7995 16.8726 10.8434 16.7668C10.8872 16.6609 10.9515 16.5648 11.0325 16.4837L12.2663 15.25L11.0238 14.0163ZM18.75 6.5H16.5625L15.9413 5.87875C15.7838 5.72125 15.5563 5.625 15.3288 5.625H11.6713C11.4438 5.625 11.2163 5.72125 11.0588 5.87875L10.4375 6.5H8.25C7.76875 6.5 7.375 6.89375 7.375 7.375C7.375 7.85625 7.76875 8.25 8.25 8.25H18.75C19.2313 8.25 19.625 7.85625 19.625 7.375C19.625 6.89375 19.2313 6.5 18.75 6.5Z"
                fill="#EB0000"
            />
        </svg>
    );
};

const IconVideo = () => {
    return (
        <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            xmlns="http://www.w3.org/2000/svg"
            style={{ backgroundColor: '#FFF8E6' }}
        >
            <rect width="60" height="60" rx="30" fill="#FFB900" />
            <path
                d="M44.56 42.7609C44.56 43.0736 44.4443 43.3735 44.2383 43.5947C44.0323 43.8158 43.7529 43.94 43.4615 43.94H17.0985C16.8071 43.94 16.5277 43.8158 16.3217 43.5947C16.1157 43.3735 16 43.0736 16 42.7609C16 42.4482 16.1157 42.1483 16.3217 41.9272C16.5277 41.706 16.8071 41.5818 17.0985 41.5818H43.4615C43.7529 41.5818 44.0323 41.706 44.2383 41.9272C44.4443 42.1483 44.56 42.4482 44.56 42.7609ZM44.56 20.3582V36.8655C44.56 37.4909 44.3285 38.0907 43.9165 38.5329C43.5045 38.9752 42.9457 39.2236 42.3631 39.2236H18.1969C17.6143 39.2236 17.0555 38.9752 16.6435 38.5329C16.2315 38.0907 16 37.4909 16 36.8655V20.3582C16 19.7328 16.2315 19.1329 16.6435 18.6907C17.0555 18.2485 17.6143 18 18.1969 18H42.3631C42.9457 18 43.5045 18.2485 43.9165 18.6907C44.3285 19.1329 44.56 19.7328 44.56 20.3582ZM35.2231 28.6118C35.223 28.4224 35.1804 28.2357 35.0989 28.0677C35.0174 27.8996 34.8994 27.7551 34.7549 27.6464L29.2625 23.5196C29.098 23.3959 28.9049 23.3229 28.7044 23.3088C28.5039 23.2946 28.3036 23.3398 28.1253 23.4393C27.9471 23.5389 27.7977 23.689 27.6934 23.8734C27.5891 24.0578 27.5339 24.2693 27.5338 24.485V32.7386C27.5339 32.9543 27.5891 33.1659 27.6934 33.3503C27.7977 33.5346 27.9471 33.6848 28.1253 33.7843C28.3036 33.8839 28.5039 33.929 28.7044 33.9149C28.9049 33.9007 29.098 33.8278 29.2625 33.704L34.7549 29.5772C34.8994 29.4685 35.0174 29.324 35.0989 29.156C35.1804 28.9879 35.223 28.8013 35.2231 28.6118Z"
                fill="white"
            />
        </svg>
    );
};

const IconDocument = () => {
    return (
        <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ backgroundColor: '#E3F6FF' }}
        >
            <rect width="60" height="60" rx="30" fill="#027DB4" />
            <path
                d="M33.75 23.75H40.625L33.75 16.875V23.75ZM25 15H35L42.5 22.5V37.5C42.5 38.163 42.2366 38.7989 41.7678 39.2678C41.2989 39.7366 40.663 40 40 40H25C24.337 40 23.7011 39.7366 23.2322 39.2678C22.7634 38.7989 22.5 38.163 22.5 37.5V17.5C22.5 16.837 22.7634 16.2011 23.2322 15.7322C23.7011 15.2634 24.337 15 25 15ZM20 20V42.5H40V45H20C19.337 45 18.7011 44.7366 18.2322 44.2678C17.7634 43.7989 17.5 43.163 17.5 42.5V20H20Z"
                fill="white"
            />
        </svg>
    );
};

const IconSort = () => {
    return (
        <svg
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_380_2682)">
                <path
                    d="M15.8335 18L12.278 14.4444H14.9447V5.55556H12.278L15.8335 2L19.3891 5.55556H16.7224V14.4444H19.3891M1.61133 16.2222V14.4444H10.5002V16.2222M1.61133 10.8889V9.11111H7.83355V10.8889M1.61133 5.55556V3.77778H5.16688V5.55556H1.61133Z"
                    fill="#A8A8A8"
                />
            </g>
            <defs>
                <clipPath id="clip0_380_2682">
                    <rect width="19" height="19" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
const IconUploadVideo = () => (
    <svg
        width="21"
        height="15"
        viewBox="0 0 21 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.0830078 3.33325C0.0830078 2.50445 0.412248 1.70959 0.998299 1.12354C1.58435 0.537492 2.37921 0.208252 3.20801 0.208252H13.6247C14.4535 0.208252 15.2483 0.537492 15.8344 1.12354C16.4204 1.70959 16.7497 2.50445 16.7497 3.33325V4.98534L19.1382 2.59679C19.2839 2.45116 19.4695 2.35198 19.6715 2.31181C19.8736 2.27164 20.083 2.29226 20.2733 2.37109C20.4636 2.44991 20.6263 2.58339 20.7407 2.75465C20.8552 2.92591 20.9163 3.12726 20.9163 3.33325V11.6666C20.9163 11.8726 20.8552 12.0739 20.7407 12.2452C20.6263 12.4164 20.4636 12.5499 20.2733 12.6287C20.083 12.7076 19.8736 12.7282 19.6715 12.688C19.4695 12.6479 19.2839 12.5487 19.1382 12.403L16.7497 10.0145V11.6666C16.7497 12.4954 16.4204 13.2902 15.8344 13.8763C15.2483 14.4623 14.4535 14.7916 13.6247 14.7916H3.20801C2.37921 14.7916 1.58435 14.4623 0.998299 13.8763C0.412248 13.2902 0.0830078 12.4954 0.0830078 11.6666V3.33325ZM9.45801 4.37492C9.45801 4.09865 9.34826 3.8337 9.15291 3.63835C8.95756 3.443 8.69261 3.33325 8.41634 3.33325C8.14007 3.33325 7.87512 3.443 7.67977 3.63835C7.48442 3.8337 7.37467 4.09865 7.37467 4.37492V6.45825H5.29134C5.01507 6.45825 4.75012 6.568 4.55477 6.76335C4.35942 6.9587 4.24967 7.22365 4.24967 7.49992C4.24967 7.77619 4.35942 8.04114 4.55477 8.23649C4.75012 8.43184 5.01507 8.54158 5.29134 8.54158H7.37467V10.6249C7.37467 10.9012 7.48442 11.1661 7.67977 11.3615C7.87512 11.5568 8.14007 11.6666 8.41634 11.6666C8.69261 11.6666 8.95756 11.5568 9.15291 11.3615C9.34826 11.1661 9.45801 10.9012 9.45801 10.6249V8.54158H11.5413C11.8176 8.54158 12.0826 8.43184 12.2779 8.23649C12.4733 8.04114 12.583 7.77619 12.583 7.49992C12.583 7.22365 12.4733 6.9587 12.2779 6.76335C12.0826 6.568 11.8176 6.45825 11.5413 6.45825H9.45801V4.37492Z"
            fill="white"
        />
    </svg>
);

const IconUploadDocument = () => (
    <svg
        width="17"
        height="21"
        viewBox="0 0 17 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2.24935 20.9166H14.7493C15.3019 20.9166 15.8318 20.6971 16.2225 20.3064C16.6132 19.9157 16.8327 19.3858 16.8327 18.8333V6.33325L10.5827 0.083252H2.24935C1.69681 0.083252 1.16691 0.302745 0.77621 0.693446C0.385509 1.08415 0.166016 1.61405 0.166016 2.16659V18.8333C0.166016 19.3858 0.385509 19.9157 0.77621 20.3064C1.16691 20.6971 1.69681 20.9166 2.24935 20.9166ZM9.54102 2.16659L14.7493 7.37492H9.54102V2.16659ZM4.33268 12.5833H7.45768V9.45825H9.54102V12.5833H12.666V14.6666H9.54102V17.7916H7.45768V14.6666H4.33268V12.5833Z"
            fill="white"
        />
    </svg>
);

const IconView = () => (
    <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M14.9458 8.85408L15.9375 9.85284L11.3121 14.5208L8.85417 12.0416L9.84583 11.0428L11.3121 12.5162L14.9458 8.85408ZM7.08333 12.0416L9.20833 14.1666H2.125V12.7499C2.125 11.1845 4.66083 9.91658 7.79167 9.91658L9.13042 9.9945L7.08333 12.0416ZM7.79167 2.83325C8.54311 2.83325 9.26378 3.13176 9.79514 3.66312C10.3265 4.19447 10.625 4.91514 10.625 5.66659C10.625 6.41803 10.3265 7.1387 9.79514 7.67005C9.26378 8.20141 8.54311 8.49992 7.79167 8.49992C7.04022 8.49992 6.31955 8.20141 5.7882 7.67005C5.25684 7.1387 4.95833 6.41803 4.95833 5.66659C4.95833 4.91514 5.25684 4.19447 5.7882 3.66312C6.31955 3.13176 7.04022 2.83325 7.79167 2.83325Z"
            fill="currentColor"
        />
    </svg>
);

const IconWaitingApprove = () => (
    <svg
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="70" height="70" rx="35" fill="#008D45" />
        <path
            d="M50 33.5165V23.3332C50 22.4491 49.6488 21.6013 49.0237 20.9761C48.3986 20.351 47.5507 19.9998 46.6667 19.9998H39.7C39 18.0665 37.1667 16.6665 35 16.6665C32.8333 16.6665 31 18.0665 30.3 19.9998H23.3333C21.5 19.9998 20 21.4998 20 23.3332V46.6665C20 47.5506 20.3512 48.3984 20.9763 49.0235C21.6014 49.6487 22.4493 49.9998 23.3333 49.9998H33.5167C35.6167 52.0665 38.4833 53.3332 41.6667 53.3332C48.1167 53.3332 53.3333 48.1165 53.3333 41.6665C53.3333 38.4832 52.0667 35.6165 50 33.5165ZM35 19.9998C35.9167 19.9998 36.6667 20.7498 36.6667 21.6665C36.6667 22.5832 35.9167 23.3332 35 23.3332C34.0833 23.3332 33.3333 22.5832 33.3333 21.6665C33.3333 20.7498 34.0833 19.9998 35 19.9998ZM25 26.6665H45V29.9998H25V26.6665ZM30.1333 43.3332H25V39.9998H30.1333C30.05 40.5498 30 41.0998 30 41.6665C30 42.2332 30.05 42.7832 30.1333 43.3332ZM25 36.6665V33.3332H33.5167C32.5 34.2832 31.7333 35.4165 31.1333 36.6665H25ZM41.6667 49.9998C37.0667 49.9998 33.3333 46.2665 33.3333 41.6665C33.3333 37.0665 37.0667 33.3332 41.6667 33.3332C46.2667 33.3332 50 37.0665 50 41.6665C50 46.2665 46.2667 49.9998 41.6667 49.9998ZM42.5 42.0832L47.2667 44.8998L46.0167 46.9332L40 43.3332V34.9998H42.5V42.0832Z"
            fill="white"
        />
    </svg>
);

const IconUploadForm = () => (
    <svg
        width="45"
        height="45"
        viewBox="0 0 45 45"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="45" height="45" rx="22.5" fill="#CEECFA" />
        <g clipPath="url(#clip0_405_2581)">
            <path
                d="M24.4531 28.7493H20.5469C19.8975 28.7493 19.375 28.2268 19.375 27.5774V19.3743H15.0928C14.2236 19.3743 13.7891 18.3245 14.4043 17.7092L21.8311 10.2776C22.1973 9.91138 22.7979 9.91138 23.1641 10.2776L30.5957 17.7092C31.2109 18.3245 30.7764 19.3743 29.9072 19.3743H25.625V27.5774C25.625 28.2268 25.1025 28.7493 24.4531 28.7493ZM35 28.3586V33.8274C35 34.4768 34.4775 34.9993 33.8281 34.9993H11.1719C10.5225 34.9993 10 34.4768 10 33.8274V28.3586C10 27.7092 10.5225 27.1868 11.1719 27.1868H17.8125V27.5774C17.8125 29.0862 19.0381 30.3118 20.5469 30.3118H24.4531C25.9619 30.3118 27.1875 29.0862 27.1875 27.5774V27.1868H33.8281C34.4775 27.1868 35 27.7092 35 28.3586ZM28.9453 32.6555C28.9453 32.1184 28.5059 31.679 27.9688 31.679C27.4316 31.679 26.9922 32.1184 26.9922 32.6555C26.9922 33.1926 27.4316 33.6321 27.9688 33.6321C28.5059 33.6321 28.9453 33.1926 28.9453 32.6555ZM32.0703 32.6555C32.0703 32.1184 31.6309 31.679 31.0938 31.679C30.5566 31.679 30.1172 32.1184 30.1172 32.6555C30.1172 33.1926 30.5566 33.6321 31.0938 33.6321C31.6309 33.6321 32.0703 33.1926 32.0703 32.6555Z"
                fill="#027DB4"
            />
        </g>
        <defs>
            <clipPath id="clip0_405_2581">
                <rect
                    width="25"
                    height="25"
                    fill="white"
                    transform="translate(10 10)"
                />
            </clipPath>
        </defs>
    </svg>
);

const IconSendMessage = () => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ marginRight: '6px' }}
    >
        <path
            d="M23.872,4.548,4.751,12.882a.438.438,0,0,0,.016.8L9.939,16.6a.834.834,0,0,0,.953-.094l10.2-8.792c.068-.057.229-.167.292-.1s-.036.224-.094.292L12.465,17.84a.831.831,0,0,0-.083.995l3.381,5.422a.44.44,0,0,0,.792-.01L24.461,5.126A.438.438,0,0,0,23.872,4.548Z"
            transform="translate(-4.503 -4.503)"
            fill="currentColor"
        />
    </svg>
);

const IconExport = () => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        style={{ marginRight: '6px' }}
    >
        <rect width="20" height="20" fill="none" />
        <path
            d="M23.417,11.557h-4.76V4.5H11.51v7.057H6.75l8.333,8.234ZM6.75,22.146V24.5H23.417V22.146Z"
            transform="translate(-4.75 -4.5)"
            fill="currentColor"
        />
    </svg>
);

export {
    IconUpgrade,
    IconUpload,
    IconDownload,
    IconEdit,
    IconDelete,
    IconVideo,
    IconDocument,
    IconSort,
    IconUploadVideo,
    IconUploadDocument,
    IconView,
    IconWaitingApprove,
    IconUploadForm,
    IconSendMessage,
    IconExport
};

